import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import IconFacilities from 'components/icons/IconFacilities';

const styles = () => ({
  root: {
    overflow: 'hidden',
  },
  grid: {
    height: 330,
  },
  iconFacilities: {
    width: 105,
    height: 94,
  },
});

const FacilitiesListEmpty = ({ classes }) => (
  <Paper className={classes.root}>
    <Grid
      className={classes.grid}
      container
      direction="column"
      justify="center"
      alignItems="center"
      spacing={24}
    >
      <Grid item>
        <IconFacilities className={classes.iconFacilities} />
      </Grid>
      <Grid item>
        <Typography variant="subheading" color="secondary">
          Unfortunately, there are no such facilities
        </Typography>
      </Grid>
    </Grid>
  </Paper>
);

FacilitiesListEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
    iconFacilities: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(FacilitiesListEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/FacilitiesList/FacilitiesListEmpty.js